import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useHistory } from 'react-router';
import PropTypes from 'prop-types';
import { Link, Typography } from '@material-ui/core';

function ClaimNumberLink({ claimNumbers, className, pathname, searchParams, state = {} }) {
  return (
    <Typography variant="subtitle1" color="textSecondary" align="center" className={className}>
      {claimNumbers.map(claim => (
        <div key={claim.qoreClaimId}>
          <Link
            color="textPrimary"
            component={RouterLink}
            to={{
              pathname: pathname ? pathname : '/claims/browse-claim',
              search: searchParams ? searchParams : `?claimId=${claim.qoreClaimId}`,
              state: { ...state, isNewClaim: true }
            }}
            variant="h5"
          >
            {claim.claimNumber}
          </Link>
          <br />
        </div>
      ))}
    </Typography>
  );
}
ClaimNumberLink.defaultProps = { state: {} };

ClaimNumberLink.propTypes = {
  className: PropTypes.string,
  claimNumbers: PropTypes.array,
  pathname: PropTypes.string,
  searchParams: PropTypes.string,
  state: PropTypes.object
};

export default ClaimNumberLink;
